export default "__VITE_ASSET__ab53e606__"